import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { Icon } from './icon.enum';

@Component({
  selector: 'app-icon',
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  /** The name of the icon to be displayed. This input is required. */
  @Input({ required: true }) name!: Icon;
  private _width = 24;
  /** The width of the icon. Defaults to 24 if not provided. */
  @Input() set width(value: number | undefined) {
    this._width = value ?? 24;
  }
  get width(): number {
    return this._width;
  }
  private _height = 24;
  /** The height of the icon. Defaults to 24 if not provided. */
  @Input() set height(value: number | undefined) {
    this._height = value ?? 24;
  }
  get height(): number {
    return this._height;
  }
  /** The color of the icon. Optional. */
  @Input() color?: string;
  /** The rotation angle of the icon in degrees. Defaults to 0 if not provided. */
  @Input() rotate?: number = 0;
  /** Custom CSS classes to be applied to the icon element. Can be a string, an array of strings, or an object with boolean values. */
  @Input() customClasses?: string | string[] | { [key: string]: boolean };
  /** Custom CSS classes to be applied to the host element. Can be a string, an array of strings, or an object with boolean values. */
  @Input() customHostClasses?: string | string[] | { [key: string]: boolean };
  @Input() ariaHidden: boolean = true; // Default to true because most icons are decorative only
  @HostBinding('class')
  get hostClasses() {
    return this.customHostClasses;
  }

  Icon = Icon;
}
